import axiosHelper from '@/utils/axiosHelper'

export default {
  // 获取下拉框数据
  getSelectData: async function (selectCode, filterStr) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/Select.GetSelectData', {
      selectCode: selectCode,
      filter: filterStr
    })
    if (rtnObj.error === '000000') {
      return rtnObj.data
    } else {
      return []
    }
  }
}
